import './App.css';
import { Twitter } from '@mui/icons-material';
import { useState } from 'react';
import { players } from './data';
import { Logo } from './Logo';
import { Guess, prepareGuessFeedback } from './Guess';
import { Keyboard } from './Keyboard';

const getDayOfYear = () => {
  var now = new Date();
  var start = new Date(now.getFullYear(), 0, 0);
  var diff = now - start;
  var oneDay = 1000 * 60 * 60 * 24;
  var day = Math.floor(diff / oneDay);
  return day;
};

function App() {
  const doy = getDayOfYear();
  const todaysPlayer = players[doy];
  const todaysCount = players[doy].name.length;

  const [guess, setGuess] = useState('');
  const [guesses, setGuesses] = useState([]);

  const submitGuess = () => {
    setGuesses((current) => [...current, guess]);
    setGuess('');
  };
  const charAsIcon = (char) => {
    const noPresent = '🏳';
    const presentButIncorrectLocation = '🏁';
    const presentAndCorrectLocation = '🏴‍☠️';

    let icon = noPresent;
    if (char.isIncludedInWord) {
      icon = presentButIncorrectLocation;
    }
    if (char.isInCorrectPosition) {
      icon = presentAndCorrectLocation;
    }
    return icon;
  };
  const guessAsIcons = (guess) => {
    const guessForIconsWithMeta = prepareGuessFeedback(
      todaysPlayer.name,
      guess
    );
    return guessForIconsWithMeta
      .map((char) => charAsIcon(char))
      .join(' ')
      .replaceAll(',', '');
  };
  const guessesAsIcons = guesses.map((guess) => guessAsIcons(guess) + '%0a');
  const twitterLink = `https://twitter.com/intent/tweet?text=Swordle. Day ${
    doy - 54
  }%0a%0a${guessesAsIcons.join('').replaceAll(',', '')}`;

  const isWon =
    guesses[guesses.length - 1]?.toUpperCase() ===
    todaysPlayer.name.toUpperCase();

  const handleDeleteClick = () => {
    setGuess((currentValue) => currentValue.slice(0, currentValue.length - 1));
  };

  const handleLetterClick = (letter) => {
    setGuess((currentValue) =>
      currentValue.length === todaysCount ? currentValue : currentValue + letter
    );
  };

  const emptyInitialGuess = [...Array(todaysCount)].map((_) => ' ');

  const paddedGuess =
    guess +
    [...Array(todaysCount - guess.length)]
      .map((_) => ' ')
      .join('')
      .replaceAll(',', '');

  const currentGuess = guess.length < 1 ? emptyInitialGuess : paddedGuess;

  return (
    <div className="App-header" style={{ backgroundColour: 'black' }}>
      <div
        style={{
          padding: '20px 0px 0px 0px',
          fontSize: '35px',
          verticalAlign: 'middle',
          textAlign: 'center',
        }}
      >
        <Logo />
      </div>
      <div
        style={{
          padding: '10px',
          fontSize: '50px',
          verticalAlign: 'middle',
          textAlign: 'center',
        }}
      >
        Swordle
      </div>

      <div style={{ padding: '10px', textAlign: 'center' }}>
        {guesses.map((guess) => (
          <Guess showFeedback guess={guess} playerName={todaysPlayer.name} />
        ))}

        {isWon && (
          <div style={{ textAlign: 'center' }}>
            Winner!!!!
            <br />
            See you tomorrow
            <br />
            <a
              class="twitter-share-button"
              href={twitterLink}
              data-size="large"
            >
              <Twitter /> Share
            </a>
          </div>
        )}
        {!isWon && (
          <Guess guess={currentGuess} playerName={todaysPlayer.name} />
        )}
        {!isWon && (
          <Keyboard
            guess={guess}
            handleLetterClick={handleLetterClick}
            todaysPlayer={todaysPlayer}
            guesses={guesses}
            todaysCount={todaysCount}
            submitGuess={submitGuess}
            handleDeleteClick={handleDeleteClick}
          />
        )}
      </div>
    </div>
  );
}

export default App;
